import Types from "./Types";

const INITIAL_STATE = {
  pdfs: [],
  lecture: {},
  isLoading: false,
  count: "",
};

export default function superadminPdfs(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.GET_SUPERADMIN_PDFS_SUCCESS: {
      return {
        ...state,
        pdfs: payload.data,
        count: payload.data.length,
      };
    }
    case Types.SUPERADMIN_GET_COURSE_PDF_SUCCESS: {
      return {
        ...state,
        pdfs: payload.data,
        count: payload.data.length,
      };
    }

    case Types.GET_SUPERADMIN_PDF_SUCCESS: {
      return {
        ...state,
        lecture: payload,
      };
    }

    case Types.EDIT_SUPERADMIN_PDF_SUCCESS: {
      let data = payload.data;
      const pdfs = state.pdfs;
      let idx = 0;
      pdfs.forEach((table, index) => {
        if (table.id === data.id) {
          idx = index;
          return;
        }
      });

      pdfs[idx] = data;
      return {
        ...state,
        pdfs: pdfs,
      };
    }

    // create
    case Types.CREATE_SUPERADMIN_PDF_SUCCESS: {
      const data = payload.data.data;
      let newArray = state.pdfs.slice();
      let index = state.pdfs.length + 1;
      newArray.splice(index, 0, data);
      return {
        ...state,
        pdfs: newArray,
      };
    }
    case Types.ADD_SUPERADMIN_PDFS_LOADING: {
      return {
        ...state,
        isLoading: payload,
      };
    }

    case Types.DELETE_SUPERADMIN_PDF_SUCCESS: {
      const newpdfs = state.pdfs.filter((item) => item.id !== payload);
      return {
        ...state,
        pdfs: newpdfs,
      };
    }
    default: {
      return state;
    }
  }
}
